module.exports = __webpack_public_path__ + "static/activities-pic-04-e7c61295d70c4cb2091f0a5e7b3e9398.jpg";